import { render, staticRenderFns } from "./multiselect.vue?vue&type=template&id=b61de176&"
import script from "./multiselect.vue?vue&type=script&lang=js&"
export * from "./multiselect.vue?vue&type=script&lang=js&"
import style0 from "./multiselect.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports